import { SeatbeltIcon } from './SeatbeltIcon';

/**
 * author: Michael Irigoyen
 * id 00F06E5E-5A05-4D5E-9D07-0573CA62E0BA
 * name seatbelt
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seatbelt.svg
 * tags
 * - Automotive 
 */
export const SafetyBeltIcon = SeatbeltIcon;
export default SafetyBeltIcon